import React, { useEffect } from "react";

import PluginLoader from "@views/plugins/PluginLoader";

const PLUGIN_KEY = "sy_localization_plugins";
export default function ActivityPlugin() {
    useEffect(() => {
        PluginLoader(PLUGIN_KEY);
    }, [])

    return (
        <div id={PLUGIN_KEY}> </div>
    );
}